module.exports = __webpack_public_path__ + "img/unit_title.9cfb079e.svg";